import styled from "styled-components";

export const MainPageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  overflow-x: hidden;
  position: relative;
`;

export const BodyContentWrapper = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  position: relative;
`;

export const ThemeButtonWrapper = styled.div`
  position: absolute;
  right: 58px;
  margin-top: -60px;
  margin-bottom: 20px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 640px) {
    right: 20px;
    margin-top: -50px;
  }

  @media (max-width: 360px) {
    right: 16px;
    margin-top: -40px;
  }
`;

export const SectionWrapper = styled.section`
  width: 100%;
  padding: 80px 0;

  @media (max-width: 640px) {
    padding: 60px 0;
  }

  @media (max-width: 360px) {
    padding: 48px 0;
  }

  &.hero {
    padding: 120px 0;
    background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);

    @media (max-width: 640px) {
      padding: 80px 0;
    }

    @media (max-width: 360px) {
      padding: 64px 0;
    }
  }

  &.features {
    background-color: #ffffff;
  }

  &.ecoya-snap {
    background-color: #f8f9fa;
  }

  &.cost-reduction {
    background-color: #0b3e91;
    color: #ffffff;
  }

  &.clients {
    background-color: #ffffff;
  }

  &.pricing {
    background-color: #f8f9fa;
  }

  &.partners {
    background-color: #ffffff;
  }

  &.faq {
    background-color: #f8f9fa;
  }

  &.contact {
    background: linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%);
    color: #ffffff;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;

  @media (max-width: 640px) {
    padding: 0 20px;
  }

  @media (max-width: 360px) {
    padding: 0 16px;
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 1248px;
  @media (max-width: 1200px) {
    margin: 0px;
    width: 100%;
  }
`;

export const Grid = styled.div<{ $columns?: number; $gap?: number }>`
  display: grid;
  grid-template-columns: repeat(${({ $columns = 3 }) => $columns}, 1fr);
  gap: ${({ $gap = 24 }) => $gap}px;
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  @media (max-width: 360px) {
    gap: 12px;
  }
`;

export const FlexRow = styled.div<{
  $justify?: "flex-start" | "center" | "flex-end" | "space-between";
  $align?: "flex-start" | "center" | "flex-end";
  $gap?: number;
  $wrap?: boolean;
}>`
  display: flex;
  justify-content: ${({ $justify = "flex-start" }) => $justify};
  align-items: ${({ $align = "center" }) => $align};
  gap: ${({ $gap = 16 }) => $gap}px;
  flex-wrap: ${({ $wrap = false }) => ($wrap ? "wrap" : "nowrap")};

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 32px;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 12px;
  }

  @media (max-width: 360px) {
    gap: 8px;
  }
`;

export const HeroContent = styled.div`
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
`;

export const FeatureCard = styled.div`
  padding: 32px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 640px) {
    padding: 24px;
  }

  @media (max-width: 360px) {
    padding: 20px;
  }
`;

export const PricingCard = styled.div<{ $highlighted?: boolean }>`
  padding: 40px;
  background: #ffffff;
  border-radius: 16px;
  border: 2px solid
    ${({ $highlighted }) => ($highlighted ? "#1a73e8" : "#e0e0e0")};
  position: relative;
  transition: all 0.3s ease;

  ${({ $highlighted }) =>
    $highlighted &&
    `
    transform: scale(1.05);
    box-shadow: 0 12px 40px rgba(26, 115, 232, 0.2);
  `}

  &:hover {
    border-color: #1a73e8;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 640px) {
    padding: 32px;
    transform: none !important;
  }

  @media (max-width: 360px) {
    padding: 24px;
  }
`;

export const StatisticItem = styled.div`
  text-align: center;
  padding: 24px;

  @media (max-width: 640px) {
    padding: 20px;
  }

  @media (max-width: 360px) {
    padding: 16px;
  }
`;

export const FAQItem = styled.div`
  padding: 24px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 640px) {
    padding: 20px;
  }

  @media (max-width: 360px) {
    padding: 16px;
  }
`;

export const FeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  padding: 100px clamp(40px, calc(44.05vw - 509.744px), 336px);
  scroll-margin-top: 80px;
  align-items: center;

  @media (max-width: 1200px) {
    padding: 100px 40px;
    gap: 100px;
  }

  @media (max-width: 920px) {
    padding: 60px 20px;
    gap: 60px;
  }
`;

export const SubSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  width: 100%;
  max-width: 1248px;
  align-items: center;

  @media (max-width: 640px) {
    gap: 56px; /* Figma 640px: maintain gap-[56px] */
  }

  @media (max-width: 360px) {
    gap: 32px;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
  text-align: center;

  @media (max-width: 640px) {
    gap: 20px;
  }

  @media (max-width: 360px) {
    gap: 16px;
  }
`;

export const ArticleCard = styled.div`
  background: #f1f4f6;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 640px) {
    border-radius: 20px;
  }

  @media (max-width: 360px) {
    border-radius: 16px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 32px;

  @media (max-width: 640px) {
    padding: 20px 24px;
  }

  @media (max-width: 360px) {
    padding: 16px 20px;
  }
`;

export const CardImagePlaceholder = styled.div<{ $backgroundColor?: string }>`
  width: 100%;
  height: 280px;
  background: ${({ $backgroundColor }) => $backgroundColor || "#1053E0"};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 640px) {
    height: 240px;
  }

  @media (max-width: 360px) {
    height: 200px;
  }
`;

export const AutomationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  @media (max-width: 360px) {
    gap: 24px;
  }
`;

export const AutomationRow = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 14px;
  }

  @media (max-width: 360px) {
    gap: 12px;
  }
`;

export const DashboardGrid = styled.div`
  display: flex;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  > * {
    flex: 1;
    min-width: 1px;
  }

  @media (max-width: 920px) {
    flex-direction: column;
    gap: 24px;
    > * {
      flex: 0 0 auto;
    }
  }

  @media (max-width: 360px) {
    gap: 24px;
  }
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  text-align: center;

  @media (max-width: 640px) {
    gap: 18px;
  }

  @media (max-width: 360px) {
    gap: 16px;
  }
`;

export const ClientsSectionWrapper = styled.div`
  width: 100%;
  background-color: #f1f4f6;
  padding: 100px clamp(40px, calc(44.05vw - 509.744px), 336px);

  @media (max-width: 640px) {
    padding: 60px 20px; /* Figma 640px: 60px vertical, 20px horizontal */
  }

  @media (max-width: 360px) {
    padding: 60px 20px; /* Figma 360px: 60px vertical, 20px horizontal */
  }
`;

export const ClientsInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;

  @media (max-width: 640px) {
    gap: 40px;
  }
`;

export const ClientsHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;
  text-align: center;

  @media (max-width: 640px) {
    gap: 28px;
  }

  @media (max-width: 360px) {
    /* Figma 360px: gap-[36px] - H2 (84px) + gap + Sub1 (52px) = 172px total */
    gap: 36px;
  }
`;

export const TestimonialCard = styled.div`
  background: #ffffff;
  border-radius: 24px;
  padding: 60px;
  display: flex;
  gap: 60px;
  align-items: flex-start;

  @media (max-width: 640px) {
    flex-direction: column;
    padding: 20px; /* Figma 640px: p-[20px] */
    gap: 20px; /* Figma 640px: gap-[20px] */
  }

  @media (max-width: 360px) {
    /* Figma 360px: p-[20px], gap-[20px] */
    padding: 20px;
    gap: 20px;
  }
`;

export const TestimonialImageContainer = styled.div`
  width: 420px;
  height: 520px;
  border-radius: 16px;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 640px) {
    width: 100%;
    height: 500px; /* Figma 640px: h-[500px] */
  }

  @media (max-width: 360px) {
    height: 360px;
  }
`;

export const TestimonialContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 520px;
  padding: 24px 0;

  @media (max-width: 640px) {
    min-height: auto;
    gap: 24px; /* Figma 640px: gap-[24px] */
  }

  @media (max-width: 360px) {
    gap: 24px;
  }
`;

export const TestimonialTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;

  @media (max-width: 640px) {
    gap: 24px; /* Figma 640px: gap-[24px] */
  }

  @media (max-width: 360px) {
    gap: 24px;
  }
`;

export const QuoteIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const TestimonialQuote = styled.div`
  text-align: center;
  padding: 0 7.47px;

  @media (max-width: 640px) {
    padding: 0;
  }
`;

export const TestimonialBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;

  @media (max-width: 640px) {
    gap: 40px; /* Figma 640px: gap-[40px] - keep desktop value */
  }

  @media (max-width: 360px) {
    /* Figma 360px: gap-[40px] between author and dots */
    gap: 40px;
  }
`;

export const TestimonialAuthor = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  text-align: center;
`;

export const CarouselDots = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;

export const CarouselDot = styled.button<{ $active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 8px;
  border: none;
  background-color: ${({ $active }) => ($active ? "#166dd7" : "#cfd6d9")};
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    background-color: ${({ $active }) => ($active ? "#166dd7" : "#aeb7bc")};
    transform: scale(1.2);
  }

  &:focus-visible {
    outline: 2px solid #166dd7;
    outline-offset: 2px;
  }
`;

export const PricingSectionWrapper = styled.div`
  width: 100%;
  background-color: #ffffff; // White background (cards are #F7F9FA)
  padding: 100px clamp(40px, calc(44.05vw - 509.744px), 336px);
  scroll-margin-top: 80px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1200px) {
    /* Figma 921px: 100px vertical, 40px horizontal */
    padding: 100px 40px;
  }

  @media (max-width: 920px) {
    padding: 60px 20px;
  }
`;

export const PricingInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;

  @media (max-width: 920px) {
    gap: 40px;
  }

  @media (max-width: 360px) {
    /* Figma 360px: gap-[40px] */
    gap: 40px;
  }
`;

export const PricingHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;
  text-align: center;

  @media (max-width: 360px) {
    /* Figma 360px: gap-[36px] between H2 and Sub1 */
    gap: 36px;
  }
`;

export const PricingGrid = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  justify-content: center; /* Center align cards */

  @media (max-width: 920px) {
    flex-direction: column;
    align-items: center; /* Center align in mobile */
  }

  @media (max-width: 360px) {
    /* Figma 360px: gap-[20px] between cards */
    gap: 20px;
  }
`;

export const PricingPlanCard = styled.div`
  background: #f7f9fa; // Gray/Gray 11
  border-radius: 16px;
  padding: 48px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
  flex: 0 1 402.667px;
  min-width: 280px;
  align-self: stretch;

  @media (max-width: 920px) {
    flex: none;
    align-self: auto;
    width: 100%;
    height: 624px; /* Figma 920px: h-[624px] */
    padding: 20px; /* Figma 920px: p-[20px] */
  }

  @media (max-width: 360px) {
    /* Figma 360px: h-[624px], p-[20px], gap-[32px] */
    padding: 20px;
    gap: 32px;
  }
`;

export const PopularBadge = styled.div`
  position: absolute;
  top: 16px;
  right: 15.34px;
  background-color: #1479eb; // Blue 5
  border-radius: 4px;
  padding: 4px 8px;
`;

export const PlanHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PriceDisplay = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`;

export const ButtonSubtitle = styled.div`
  text-align: center;
  min-height: 24px;
  padding-top: 0;
  padding-bottom: 3px;
`;

export const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FeatureHeader = styled.div`
  max-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FeatureItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const CheckIconWrapper = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background-color: #166dd7; // Blue 4
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 14px;
    height: 14px;
  }
`;

export const PricingFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PartnersSectionWrapper = styled.div`
  background-color: #f7f9fa; // Gray/Gray 11
  max-width: 1920px; /* Match BodyContentWrapper max-width */
  margin: 0 auto; /* Center the content */
  padding: 88px clamp(20px, 17vw, 336px);
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 640px) {
    padding: 88px 20px; /* Figma 640px: py-[88px] px-[20px] */
  }
`;

export const PartnersLogoGrid = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap; 
  overflow-x: auto;
  width: 100%;

  
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none; 
  }

  @media (max-width: 360px) {
    gap: 40px;
  }
`;

export const PartnerLogoItem = styled.div`
  width: 200px; /* Figma: Margin wrapper width */
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  /* Inner container for actual logo */
  > div {
    width: 126px; /* Figma: Container width */
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 640px & 360px: 200px × 40px, Container 126px × 40px 동일 유지 */
`;

export const FAQSectionWrapper = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 100px clamp(40px, calc(44.05vw - 509.744px), 336px);
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1200px) {
    /* Figma 921px: py-[100px] px-[40px] */
    padding: 100px 40px;
  }

  @media (max-width: 920px) {
    padding: 60px 20px;
  }

  @media (max-width: 360px) {
    /* Figma 360px: py-[60px] px-[20px] */
    padding: 60px 20px;
  }
`;

export const FAQInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;

  @media (max-width: 920px) {
    gap: 40px;
  }

  @media (max-width: 360px) {
    /* Figma 360px: gap-[40px] */
    gap: 40px;
  }
`;

export const FAQHeading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const FAQList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px; /* Figma: item spacing/xs */
  width: 1248px; /* Figma: List width at x=336, width=1248 */
  max-width: 100%;
  margin: 0 auto; /* Center align */

  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const FAQItemWrapper = styled.div<{ $isOpen: boolean }>`
  background: ${({ $isOpen }) =>
    $isOpen ? "#f7f9fa" : "#f1f4f6"}; /* Gray 11 open, Gray 10 closed */
  border-radius: 16px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: ${({ $isOpen }) => ($isOpen ? "20px" : "0")};
  transition: all 0.3s ease;

  @media (max-width: 920px) {
    padding: 20px; /* Figma 920px: p-[20px] */
  }
`;

export const FAQButton = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;

export const FAQQuestion = styled.div`
  flex: 1;
  min-width: 0; /* Allow text to wrap */
`;

export const IconButton = styled.div<{ $isOpen: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 24px;
  background-color: ${({ $isOpen }) =>
    $isOpen ? "#1c3d61" : "#ffffff"}; /* Indigo open, White closed */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 6px;
  transition: all 0.3s ease;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
`;

export const MinusIcon = styled.div`
  width: 14.67px;
  height: 1.25px;
  background-color: #ffffff;
  border-radius: 14px;
`;

export const FAQAnswer = styled.div`
  width: 100%;
  overflow: hidden;

  @media (max-width: 640px) {
    font-size: 15px;
    line-height: 22px;
  }

  @media (max-width: 360px) {
    font-size: 14px;
    line-height: 21px;
  }
`;

/**
 * ContactSection Styled Components
 * Based on Figma design (node-id=89-25289)
 */

export const ContactSectionWrapper = styled.div`
  width: 100%;
  background-color: #f7f9fa;
  padding: 100px clamp(40px, calc(44.05vw - 509.744px), 336px);
  scroll-margin-top: 80px;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1200px) {
    /* Figma 1200px~921px: py-[100px] px-[40px] */
    padding: 100px 40px;
  }

  @media (max-width: 920px) {
    padding: 100px 20px;
  }

  @media (max-width: 360px) {
    /* Figma 360px: py-[100px] px-[20px] */
    padding: 100px 20px;
  }
`;

export const ContactInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;

  @media (max-width: 640px) {
    gap: 40px;
  }

  @media (max-width: 360px) {
    /* Figma 360px: gap-[56px] */
    gap: 56px;
  }
`;

export const ContactSectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;
  text-align: center;
  width: 100%;
`;

export const ContactSectionSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  text-align: center;

  @media (max-width: 640px) {
    gap: 12px;
  }

  @media (max-width: 360px) {
    gap: 8px;
  }
`;

export const ContactButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 16px;
`;

export const FooterSectionWrapper = styled.footer`
  width: 100%;
  background-color: #222729;
  padding: 96px clamp(40px, calc(44.05vw - 509.744px), 336px);
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1200px) {
    padding: 96px 40px;
  }

  @media (max-width: 920px) {
    padding: 60px 20px;
  }
`;

export const FooterInnerWrapper = styled.div`
  display: flex;
  gap: 40px;
  align-items: flex-start;

  @media (max-width: 920px) {
    flex-direction: column; /* Figma 920px: vertical layout */
  }
`;
